import {
	ApplicationConfig,
	importProvidersFrom,
	provideZonelessChangeDetection,
} from '@angular/core';
import {
	InMemoryScrollingOptions,
	provideRouter,
	withComponentInputBinding,
	withInMemoryScrolling,
	withViewTransitions,
} from '@angular/router';
import { routes } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
	HttpBackend,
	HttpClient,
	provideHttpClient,
	withInterceptors,
	withXhr,
} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HeadersInterceptor } from '@interceptor/headers-interceptor';
import { provideKoneUI } from '@kone/ui';

const scrollConfig: InMemoryScrollingOptions = {
	scrollPositionRestoration: 'enabled',
	anchorScrolling: 'disabled',
};

export const appConfig: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withComponentInputBinding(),
			withViewTransitions(),
			withInMemoryScrolling(scrollConfig),
		),
		provideKoneUI(),
		provideHttpClient(withXhr(), withInterceptors([HeadersInterceptor])),
		importProvidersFrom(
			TranslateModule.forRoot({
				defaultLanguage: 'en',
				loader: {
					provide: TranslateLoader,
					useFactory: (httpHandler: HttpBackend) => {
						return new TranslateHttpLoader(
							new HttpClient(httpHandler),
							'./assets/i18n/',
						);
					},
					deps: [HttpBackend],
				},
			}),
		),
	],
};
